var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.invisible ? 'tw-invisible tw-h-0 tw-overflow-hidden' : ''},[_c('canvas',{class:_vm.canvasClass,attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }